<script lang="ts">
	import { route } from '$lib/ROUTES'
	import FooterLinksToWeb from '$lib/components/footer/FooterLinksToWeb.svelte'
	import Logo from '$lib/domain/logo/Logo.svelte'
	import { illustrationPosition } from './illustrationPosition'
	import { _ } from '@repo/i18n'
	import { user } from '@repo/ui'
	import type { Snippet } from 'svelte'

	interface Props {
		affiliate?: boolean
		minimalist?: boolean
		additionalClasses?: string
		disableLogo?: boolean
		loginUrl?: any
		logo?: Snippet
		login?: Snippet
		illustration?: Snippet
		children?: Snippet
		bottom?: Snippet
	}

	let {
		affiliate = false,
		minimalist = false,
		additionalClasses = '',
		disableLogo = false,
		loginUrl = route('/'),
		logo,
		login,
		illustration,
		children,
		bottom,
	}: Props = $props()
</script>

<div
	class="max-md:dark:bg-gray-1000 bg-white dark:bg-gray-900
	       {!minimalist ? 'md:grid-cols-golden-ratio-2 md:grid md:min-h-screen' : ''}"
>
	<div
		class="px-4 py-5 md:relative md:w-full md:max-w-3xl md:py-10 md:pr-10
		       {!minimalist ? 'ml-auto' : 'mx-auto'}"
	>
		<div class="flex flex-wrap items-center justify-between gap-4">
			<a class:pointer-events-none={disableLogo} href="/">
				{#if logo}{@render logo()}{:else}
					<Logo />
				{/if}
			</a>

			{@render login?.()}
		</div>

		{#if !minimalist && affiliate && $illustrationPosition === 'top'}
			<div class="mt-5 md:hidden">
				{@render illustration?.()}
			</div>
		{/if}

		<div class="mt-14"></div>

		{@render children?.()}

		{#if !$user}
			<p class="my-8 text-center md:text-left">
				{$_('login.doYouHaveAccount')}
				<a class="text-link" href={loginUrl}>
					<strong class="text-black dark:text-white">
						{$_('login.headline')}
					</strong>
				</a>
			</p>
		{/if}

		{@render bottom?.()}

		{#if !affiliate || $illustrationPosition === 'bottom'}
			<div class="mt-5 md:hidden">
				{@render illustration?.()}
			</div>
		{/if}

		<div class="m-auto my-8 w-32 border-t border-t-gray-200 md:hidden dark:border-t-gray-700"></div>
		<div class="hidden md:block md:h-20"></div>
		<div
			class="flex flex-col space-y-6 text-center text-sm md:absolute md:bottom-0 md:h-20 md:flex-row md:items-center md:space-y-0 md:space-x-12 md:text-left"
		>
			<FooterLinksToWeb affiliateTerms={affiliate} />
		</div>
	</div>

	{#if !minimalist}
		<div class="relative hidden overflow-hidden md:flex {additionalClasses}">
			{@render illustration?.()}
		</div>
	{/if}
</div>
